import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { isHosTheme } = getTheme();

export const styles = {
    header: css({
        textTransform: isHosTheme ? 'none' : 'uppercase',
        fontWeight: 'bold',
        gap: '8px',
        ...(isHosTheme && {
            paddingTop: '8px',
        }),
    }),
    closeButton: css({
        padding: '0',
    }),
};
